import angular from 'angular';

const dishesServices = angular.module('applicationModule.dishesServices', []);

const checkFiles = function (file) {
    'use strict';
    const files = [];
    const names = [];
    if (angular.isDefined(file)) {
        files.push(file);
        names.push('file');
    }

    return {files: files, names: names};
};

dishesServices.factory('Dish', ['DishAPI', function (DishAPI) {
    'use strict';
    return {
        list: function (appId, params) {
            return DishAPI.index(appId, params)
                .then(function (response) {
                    return response.data;
                });
        },
        exhibitors: function (appId) {
            return DishAPI.exhibitors(appId);
        },
        save: function (data, file, editMode) {
            if (editMode) {
                return DishAPI.update(data, file);
            }

            return DishAPI.store(data, file);
        },
        ingredients: function (appId, search) {
            return DishAPI.ingredients(appId, search);
        },
        get: function (dishId, appId) {
            return DishAPI.get(dishId, appId);
        },
        remove: function (dishId) {
            return DishAPI.remove(dishId);
        }
    };
}]);

dishesServices.service('DishAPI', ['$http', 'AppsoupAPI', 'Upload', function ($http, AppsoupAPI, Upload) {
    'use strict';
    const API_URL = AppsoupAPI.API_URL + '/app/dishes/';

    this.index = function (appId, params) {
        return $http.get(API_URL, {params: angular.extend(AppsoupAPI.getTableParams(params), {application_id: appId})});
    };

    this.exhibitors = function (appId) {
        return $http.get(API_URL + 'exhibitors/' + appId);
    };

    this.store = function (data, file) {
        const files = checkFiles(file);
        if (angular.isDefined(file)) {
            return Upload.upload({
                url: API_URL,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: data,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.post(API_URL, data);
        }
    };

    this.update = function (data, file) {
        const files = checkFiles(file);
        if (angular.isDefined(file)) {
            const newfields = angular.extend(data, {_method: 'PUT'});

            return Upload.upload({
                url: API_URL + data.id,
                method: 'POST',
                sendObjectsAsJsonBlob: false,
                fields: newfields,
                file: files.files,
                fileFormDataName: files.names
            });
        } else {
            return $http.put(API_URL + data.id, data);
        }
    };

    this.ingredients = function (appId, search) {
        search = encodeURIComponent(search);

        return $http.get(API_URL + 'autocomplete/' + appId + '/' + search);
    };

    this.get = function (dishId, appId) {
        return $http.get(API_URL + dishId, {params: {application_id: appId}});
    };

    this.remove = function (dishId) {
        return $http.delete(API_URL + dishId);
    };
}]);

export default dishesServices;
